<template>
  <div>
    <VRevolucion
      :breakpoint="breakpoint"
    />

    <div
      class="mx-auto"
      id="reservar"
      :class="$style['box-form']"
    >
      <div>
        <VGrid>
          <VGridColumn col="full">
            <div class="text-center mb-20">
              <h1 class="text-xl text-center">
                Reserva ya tu plaza
              </h1>

              <span
                v-if="isConcessionaryRoute"
                class="font-light mt-4"
              ><br> en {{ concessionary.name }}</span>
            </div>
          </VGridColumn>

          <VGridColumn
            v-if="!isConcessionaryRoute"
            col="full"
            col-sm="1/2"
            col-md="1/3"
          >
            <VCitiesField
              ref="city"
              label="Ciudad"
              class="sm:mr-4"
              v-model="fields.city"
              optional
              @change="onCitiesChange"
            />
          </VGridColumn>

          <VGridColumn
            v-if="!isConcessionaryRoute"
            col="full"
            col-sm="1/2"
            col-md="1/3"
          >
            <VConcessionairesField
              ref="concessionary"
              label="Ubicación"
              :slug="fields.city"
              :no-places-available="noPlacesAvailable"
              class="sm:mr-4"
              v-model="fields.concessionary"
              optional
              @change="onConcessionairesChange"
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-sm="1/2"
            col-md="1/3"
          >
            <VVehiclesField
              ref="vehicle"
              label="Vehículo"
              :slug="fields.concessionary"
              class="sm:mr-4"
              v-model="fields.vehicle"
              optional
              @activityListLoaded="onActivityListLoaded"
              @placesAvailable="onPlacesAvailable"
              @change="onVehiclesChange"
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-sm="1/2"
            col-md="1/3"
          >
            <VDatesField
              ref="date"
              label="Fecha"
              class="sm:mr-4"
              :options="dateList"
              :disabled="!fields.vehicle || (dateOptions[fields.vehicle] || []).length === 0"
              v-model="fields.date"
              optional
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-sm="1/2"
            col-md="1/3"
          >
            <VSchedulesField
              ref="schedule"
              label="Horario"
              class="sm:mr-4"
              :options="scheduleList"
              :disabled="!fields.date || scheduleOptions[fields.vehicle][fields.date].length === 0"
              v-model="fields.schedule"
              optional
            />
          </VGridColumn>
        </VGrid>

        <div
          class="mt-5 mb-8 ml-4 text-base leading-tight text-secondary-grey"
          :class="$style['label-color']"
        >
          <p class="text-xs text-justify">
            Si no aparecen turnos habilitados es que las plazas están completas, si quieres participar escríbenos a
            <a
              href="mailto:atencioncliente@audi.es"
              target="_blank"
              class="text-grey-90"
            >
              atencioncliente@audi.es
            </a>
          </p>
        </div>

        <h1 class="text-xl mb-10 text-center mt-20">
          Datos de contacto
        </h1>

        <VGrid>
          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VTitleField
              ref="title"
              v-model="fields.title"
              class="sm:mr-4"
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VFirstNameField
              ref="firstName"
              v-model="fields.firstName"
              class="sm:mr-4"
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VLastNameField
              ref="lastName"
              v-model="fields.lastName"
              class="sm:mr-4"
            />
          </VGridColumn>
        </VGrid>

        <VGrid>
          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VSecondLastNameField
              ref="secondLastName"
              v-model="fields.secondLastName"
              class="sm:mr-4"
            />
          </VGridColumn>
          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VEmailField
              ref="email"
              v-model="fields.email"
              class="sm:mr-4"
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VPhoneField
              ref="phone"
              v-model="fields.phone"
              class="sm:mr-4"
            />
          </VGridColumn>
        </VGrid>

        <VGrid>
          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VDateOfBirthField
              ref="dateOfBirth"
              v-model="fields.dateOfBirth"
              class="sm:mr-4"
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VDniField
              ref="dni"
              v-model="fields.dni"
              class="sm:mr-4"
            />
          </VGridColumn>

          <VGridColumn
            col="full"
            col-md="1/3"
          >
            <VPostalCodeField
              ref="postalCode"
              v-model="fields.postalCode"
              class="sm:mr-4"
            />
          </VGridColumn>
        </VGrid>

        <VGrid>
          <VGridColumn
            col="full"
          >
            <VCheckCommercialField
              ref="checkCommercial"
              v-model="fields.checkCommercial"
              class="sm:mt-10"
            />
          </VGridColumn>
        </VGrid>

        <VGrid>
          <VGridColumn
            col="full"
          >
            <VCheckProfileField
              ref="checkProfile"
              v-model="fields.checkProfile"
            />
          </VGridColumn>
        </VGrid>

        <div
          v-if="backError"
          class="bg-danger-90 mt-8 px-3 py-2 text-xs text-danger-30"
        >
          {{ backError }}
        </div>
      </div>

      <div class="mt-10 mb-12 font-normal text-center">
        <VButton
          class="text-lg button-white rounded"
          :disabled="loading"
          :loading="loading"
          theme="white"
          @click="onSubmit"
          type="button"
        >
          {{ submitText }}
        </VButton>
      </div>

      <div
        class="mt-5 mb-8 text-base leading-tight text-secondary-grey"
        :class="$style['label-color']"
      >
        <p class="text-xs text-justify">
          Se podrá reservar una única plaza por persona.
        </p>
        <p class="text-xs mt-4 text-justify">
          Al enviar este formulario confirmas haber leído y aceptado nuestra
          <a
            href="https://cdn.eventosaudi.com/files/audietrondrive/Politica-de-Privacidad-Audi.pdf"
            target="_blank"
            class="text-grey-90"
          >
            Política de Datos y Privacidad
          </a>
          y nuestra
          <a
            href="https://cdn.eventosaudi.com/files/audietrondrive/Directrices-Pol%C3%ADtica-de-Cookies.pdf"
            target="_blank"
            class="text-grey-90"
          >
            Política de cookies
          </a>
        </p>
        <p class="text-xs mt-4 text-justify">
          El responsable del tratamiento de tus datos es Volkswagen Group España con la finalidad de atender tu consulta, realizar encuestas y para las finalidades adicionales que hayas aceptado. Tus datos podrán ser comunicados al concesionario seleccionado, para la prestación del servicio solicitado. Tienes derecho a retirar tus consentimientos, así como oponerte al tratamiento, limitar el mismo, acceder, rectificar, suprimir los datos y ejercer tu derecho a portabilidad en <a
            href="mailto:atencioncliente@audi.es"
            class="text-grey-90"
          >atencioncliente@audi.es</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import { DateTime } from 'luxon'

import { EventBus } from '@/utils'

import {
  VButton,
  VGrid,
  VGridColumn
} from '@c/base'

import {
  VCitiesField,
  VConcessionairesField,
  VVehiclesField,
  VDatesField,
  VSchedulesField,
  VTitleField,
  VFirstNameField,
  VLastNameField,
  VSecondLastNameField,
  VEmailField,
  VPhoneField,
  VPostalCodeField,
  VDniField,
  VCheckCommercialField,
  VCheckProfileField,
  VDateOfBirthField
} from '@c/fields'

import AttendeeFormModal from '@c/modals/AttendeeFormModal'
import VRevolucion from '@c/Revolucion'

export default {
  components: {
    VCitiesField,
    VConcessionairesField,
    VVehiclesField,
    VDatesField,
    VSchedulesField,
    VButton,
    VGrid,
    VGridColumn,
    VRevolucion,
    VTitleField,
    VFirstNameField,
    VLastNameField,
    VSecondLastNameField,
    VEmailField,
    VPhoneField,
    VPostalCodeField,
    VDniField,
    VCheckCommercialField,
    VCheckProfileField,
    VDateOfBirthField
  },

  data () {
    return {
      loading: false,
      activityList: null,
      fields: {
        city: '',
        concessionary: '',
        vehicle: '',
        date: '',
        schedule: '',
        title: '',
        firstName: '',
        lastName: '',
        secondLastName: '',
        dni: '',
        email: '',
        phone: '',
        postalCode: '',
        dateOfBirth: '',
        checkCommercial: null,
        checkProfile: null
      },
      dateOptions: [],
      scheduleOptions: [],
      attendeeData: {},
      backError: '',
      noPlacesAvailable: false,
      concessionary: window.concessionary,
      breakpoint: 0
    }
  },

  computed: {

    submitText () {
      if (this.loading) {
        return 'Cargando'
      }

      return this.accessWaitingList ? 'Apúntate a la lista de espera' : 'Reservar'
    },
    activityToBook () {
      return {
        attendee: this.attendeeData,
        workshops: this.activityList && this.fields.schedule
          ? this.activityList[this.fields.vehicle]
            .filter(activity =>
              activity.date === this.fields.date &&
              activity.time === this.fields.schedule
            )
            .map(activity => ({
              action_uuid: activity.action.id,
              experienceRef: activity.action.ref,
              workshop: activity.name,
              ref: activity.ref
            }))
          : []
      }
    },

    dateList () {
      return this.fields.vehicle
        ? this.dateOptions[this.fields.vehicle]
        : []
    },

    scheduleList () {
      return this.fields.date
        ? this.scheduleOptions[this.fields.vehicle][this.fields.date]
        : []
    },

    isConcessionaryRoute () {
      return this.concessionary && this.$route.name === 'concessionary'
    }
  },

  created () {
    this.refreshBreakpoint()
    window.addEventListener('resize', _.throttle(this.refreshBreakpoint))

    this.fields.concessionary = this.isConcessionaryRoute
      ? this.concessionary.slug
      : ''

    if (this.$route.params.concessionary && !this.concessionary) {
      this.$router.replace({ name: '404' })
    }

    EventBus.$on('workshopConflict', workshopConflict => {
      this.attendeeData = workshopConflict.attendeeData
      this.backError = workshopConflict.errorData.message
    })
  },

  methods: {
    refreshBreakpoint () {
      this.breakpoint = parseInt(window
        .getComputedStyle(document.querySelector('body'), ':before')
        .getPropertyValue('content')
        .replace(/"/g, ''))
    },

    transformActivities (activities) {
      let list = {
        dates: {},
        schedules: {}
      }

      let yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)

      _.forEach(activities, (activity, activityRef) => {
        // Get dates from activities (.map) and remove duplicate values (.filter)
        list.dates[activityRef] = activities[activityRef]
          .map(workshop => workshop.date)
          .filter((value, index, self) => self.indexOf(value) === index)

        // Reformat dates result with key => value, where value is human date format
        list.dates[activityRef] = _.reduce(list.dates[activityRef], (result, date) => {
          result[date] = DateTime.fromFormat(date, 'yyyy-LL-dd').toFormat('DD')

          return result
        }, {})

        // Only future dates
        list.dates[activityRef] = _.pickBy(list.dates[activityRef], function (value, date) {
          return yesterday.getTime() < Date.parse(date)
        })

        // Get hours from each date on each activity
        list.schedules[activityRef] = _.reduce(activities[activityRef], (result, workshop) => {
          (result[workshop.date] || (result[workshop.date] = [])).push(workshop.time)

          return result
        }, {})
      })

      return list
    },

    onActivityListLoaded (activityList) {
      this.activityList = activityList

      let transformedActivities = this.transformActivities(activityList)

      this.dateOptions = transformedActivities.dates
      this.scheduleOptions = transformedActivities.schedules
    },

    onPlacesAvailable (hasPlacesAvailable) {
      this.noPlacesAvailable = hasPlacesAvailable
    },

    toAttendeeFormStep () {
      if (this.hasValidationError()) {
        return
      }
      this.$modal.show(AttendeeFormModal, {
        concessionary: this.fields.concessionary,
        activityToBook: this.activityToBook
      })
    },

    hasValidationError () {
      let errors = []

      const fieldsToValidate = this.concessionary
        ? {
          vehicle: this.fields.vehicle,
          date: this.fields.date,
          schedule: this.fields.schedule,
          title: this.fields.title,
          firstName: this.fields.firstName,
          lastName: this.fields.lastName,
          secondLastName: this.fields.secondLastName,
          email: this.fields.email,
          phone: this.fields.phone,
          dateOfBirth: this.fields.dateOfBirth,
          checkCommercial: this.fields.checkCommercial,
          checkProfile: this.fields.checkProfile
        }
        : this.fields

      // Touch each form field and check if has error
      _.forEach(fieldsToValidate, (field, fieldKey) => {
        this.$refs[fieldKey].$v.$touch()

        if (this.$refs[fieldKey].$v[fieldKey].$error) {
          errors.push(fieldKey)
        }
      })

      return errors.length > 0
    },

    onCitiesChange () {
      this.fields.concessionary = ''
      this.fields.vehicle = ''
      this.fields.date = ''
      this.fields.schedule = ''
      this.noPlacesAvailable = false
    },

    onConcessionairesChange () {
      this.fields.vehicle = ''
      this.fields.date = ''
      this.fields.schedule = ''
    },

    onVehiclesChange () {
      this.fields.date = ''
      this.fields.schedule = ''
    },
    onSubmit () {
      if (this.hasValidationError() || this.loading) {
        return
      }

      this.backError = ''
      this.validationErrors = {}
      this.loading = true

      this.submit()
        .then(response => {
          this.$router.push({
            name: 'success',
            params: response.data.data
          })
        })
        .catch(error => {
          let errorData = error.response.data
          this.backError = errorData.message

          if (errorData.category && errorData.category === 'validation') {
            let completeKey = _.map(errorData.data, (value, key) => key)[0]
            let keySplitted = completeKey.split('.')
            let key = keySplitted[keySplitted.length - 1]

            if (key === 'workshops') {
              this.backError = 'Ha habido un error a la hora de procesar los datos de la actividad.'
            }

            _.set(this.validationErrors, _.camelCase(key), errorData.data[completeKey][0])
          }

          if (errorData.category && errorData.category === 'workshop_conflict') {
            EventBus.$emit('workshopConflict', {
              attendeeData: this.fields,
              errorData: errorData
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit () {
      return axios.post('/api/activities/' + this.fields.concessionary, {
        activityToBook: {
          attendee: _.mapKeys(this.fields, (v, k) => _.snakeCase(k)),
          workshops: this.activityToBook.workshops.map(workshop => _.mapKeys(workshop, (v, k) => _.snakeCase(k)))
        }
      })
    },

    reload () {
      this.initialError = false
      this.backError = null

      window.scrollTo(0, 0)
      location.reload()
    }
  }
}
</script>

<style lang="scss" module>
.box {
  max-width: 1200px;
}

.title {
  @apply text-center;
  @apply font-audi-type-extendednormal;
  @apply px-0;

  font-size: 16px;
  line-height: 16px;
  font-weight: 600;

  & > span {
    @apply font-audi-type-normal;
    @apply font-light;
  }
}

.box-form {
  max-width: 1200px;
  @apply bg-black;
  @apply text-white;
  @apply p-10;
}

@media (min-width: 576px) {
  .box-form {
    @apply p-20;
    @apply mb-10;
  }

  .title {
    @apply px-10;
    font-size: 16px;
    line-height: 20px;
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 16px;
    line-height: 20px;
  }
}

@media (min-width: 960px) {
  .title {
    font-size: 26px;
    line-height: 46px;
  }
}
</style>
